// KPMG Insights destinations grouped by region.
// Each entry: { name, url, region, aliases? }.
// `aliases` lets a regional umbrella entry match country-name searches —
// e.g. searching "Kenya" surfaces the "East Africa" card.

const RAW = [
  { name: "Global", url: "https://kpmg.com/xx/en/our-insights.html", region: "Global" },

  // ---- Africa ----
  { name: "Algeria", url: "https://kpmg.com/dz/fr/home/insights.html", region: "Africa" },
  { name: "Cameroon", url: "https://kpmg.com/cm/fr/home/actualites.html", region: "Africa" },
  { name: "DR Congo", url: "https://kpmg.com/cd/fr/home.html", region: "Africa" },
  {
    name: "East Africa",
    url: "https://kpmg.com/ke/en/home/insights.html",
    region: "Africa",
    aliases: [
      "Kenya", "Uganda", "Tanzania", "Rwanda", "Burundi",
      "South Sudan", "Ethiopia", "Somalia", "Eritrea", "Djibouti",
      "Eastern Africa", "EAC", "TZ", "UG", "RW",
    ],
  },
  {
    name: "West Africa",
    url: "https://kpmg.com/ng/en/home/insights.html",
    region: "Africa",
    aliases: [
      "Nigeria", "Ghana", "Senegal", "Ivory Coast", "Cote d'Ivoire",
      "Togo", "Benin", "Burkina Faso", "Mali", "Liberia",
      "Sierra Leone", "Gambia", "Guinea", "Guinea-Bissau", "Niger",
      "Cape Verde", "Mauritania", "ECOWAS", "Western Africa",
    ],
  },
  {
    name: "Southern Africa",
    url: "https://kpmg.com/za/en/home/insights.html",
    region: "Africa",
    aliases: [
      "South Africa", "Botswana", "Lesotho", "Eswatini", "Swaziland",
      "Namibia", "Zambia", "Zimbabwe", "Mozambique", "Angola",
      "Malawi", "Madagascar", "Mauritius", "SADC",
    ],
  },
  {
    name: "North Africa",
    url: "https://kpmg.com/eg/en/home/insights.html",
    region: "Africa",
    aliases: [
      "Egypt", "Algeria", "Tunisia", "Morocco", "Libya", "Sudan",
      "Maghreb", "Northern Africa",
    ],
  },
  {
    name: "Central Africa",
    url: "https://kpmg.com/cm/fr/home/actualites.html",
    region: "Africa",
    aliases: [
      "Cameroon", "DR Congo", "Democratic Republic of Congo",
      "Republic of Congo", "Chad", "Central African Republic",
      "Gabon", "Equatorial Guinea", "Sao Tome",
    ],
  },
  { name: "Egypt", url: "https://kpmg.com/eg/en/home/insights.html", region: "Africa" },
  { name: "Ghana", url: "https://kpmg.com/gh/en/home/insights.html", region: "Africa" },
  { name: "Ivory Coast", url: "https://kpmg.com/ci/fr/home/insights.html", region: "Africa" },
  { name: "Mauritius", url: "https://kpmg.com/za/en/home/insights.html", region: "Africa" },
  { name: "Mozambique", url: "https://kpmg.com/za/en/home/insights.html", region: "Africa" },
  { name: "Namibia", url: "https://kpmg.com/za/en/home/insights.html", region: "Africa" },
  { name: "Nigeria", url: "https://kpmg.com/ng/en/home/insights.html", region: "Africa" },
  { name: "Senegal", url: "https://kpmg.com/sn/fr/home/insights.html", region: "Africa" },
  { name: "South Africa", url: "https://kpmg.com/za/en/home/insights.html", region: "Africa" },
  { name: "Togo", url: "https://kpmg.com/tg/fr/home/insights.html", region: "Africa" },
  { name: "Tunisia", url: "https://kpmg.com/tn/en/home/insights.html", region: "Africa" },
  { name: "Zambia", url: "https://kpmg.com/za/en/home/insights.html", region: "Africa" },
  { name: "Zimbabwe", url: "https://kpmg.com/za/en/home/insights.html", region: "Africa" },

  // ---- Europe ----
  { name: "Albania", url: "https://kpmg.com/al/en/home/insights.html", region: "Europe" },
  { name: "Austria", url: "https://kpmg.com/at/de/home/insights.html", region: "Europe" },
  { name: "Belgium", url: "https://kpmg.com/be/en/home/insights.html", region: "Europe" },
  { name: "Bosnia & Herzegovina", url: "https://kpmg.com/ba/en/home/insights.html", region: "Europe" },
  { name: "Bulgaria", url: "https://kpmg.com/bg/en/home/insights.html", region: "Europe" },
  { name: "Channel Islands", url: "https://kpmg.com/dp/en/home/insights.html", region: "Europe" },
  { name: "Croatia", url: "https://kpmg.com/hr/en/home/insights.html", region: "Europe" },
  { name: "Cyprus", url: "https://kpmg.com/cy/en/home/insights.html", region: "Europe" },
  { name: "Czech Republic", url: "https://kpmg.com/cz/cs/home/clanky-a-analyzy.html", region: "Europe" },
  { name: "Denmark", url: "https://kpmg.com/dk/en/home/insights.html", region: "Europe" },
  { name: "Estonia", url: "https://kpmg.com/ee/en/home/insights.html", region: "Europe" },
  { name: "Finland", url: "https://kpmg.com/fi/fi/home/Pinnalla.html", region: "Europe" },
  { name: "France", url: "https://kpmg.com/fr/fr/insights.html", region: "Europe" },
  { name: "Georgia", url: "https://kpmg.com/ge/en/home/insights.html", region: "Europe" },
  { name: "Germany", url: "https://kpmg.com/de/en/home/insights.html", region: "Europe" },
  { name: "Gibraltar", url: "https://kpmg.com/gi/en/home/insights.html", region: "Europe" },
  { name: "Greece", url: "https://kpmg.com/gr/en/home/insights.html", region: "Europe" },
  { name: "Hungary", url: "https://kpmg.com/hu/en/home/insights.html", region: "Europe" },
  { name: "Iceland", url: "https://kpmg.com/is/is/home/insights.html", region: "Europe" },
  { name: "Ireland", url: "https://kpmg.com/ie/en/home/insights.html", region: "Europe" },
  { name: "Isle of Man", url: "https://kpmg.com/dp/en/home/insights.html", region: "Europe" },
  { name: "Italy", url: "https://kpmg.com/it/it/home/insights.html", region: "Europe" },
  { name: "Latvia", url: "https://kpmg.com/lv/en/home/insights.html", region: "Europe" },
  { name: "Lithuania", url: "https://kpmg.com/lt/en/insights.html", region: "Europe" },
  { name: "Luxembourg", url: "https://kpmg.com/lu/en/home/insights.html", region: "Europe" },
  { name: "Malta", url: "https://kpmg.com/mt/en/home/insights.html", region: "Europe" },
  { name: "Moldova", url: "https://kpmg.com/md/en/home/insights.html", region: "Europe" },
  { name: "Monaco", url: "https://kpmg.com/mc/en/home/insights.html", region: "Europe" },
  { name: "Montenegro", url: "https://kpmg.com/me/en/home/insights.html", region: "Europe" },
  { name: "Netherlands", url: "https://kpmg.com/nl/en/home/insights.html", region: "Europe" },
  { name: "North Macedonia", url: "https://kpmg.com/mk/en/home/insights.html", region: "Europe" },
  { name: "Norway", url: "https://kpmg.com/no/nb.html", region: "Europe" },
  { name: "Poland", url: "https://kpmg.com/pl/en/home/insights.html", region: "Europe" },
  { name: "Portugal", url: "https://kpmg.com/pt/pt/home/insights.html", region: "Europe" },
  { name: "Romania", url: "https://kpmg.com/ro/en/home/insights.html", region: "Europe" },
  { name: "Serbia", url: "https://kpmg.com/rs/en/home/insights.html", region: "Europe" },
  { name: "Slovakia", url: "https://kpmg.com/sk/en/home/insights.html", region: "Europe" },
  { name: "Slovenia", url: "https://kpmg.com/xx/en/our-insights.html", region: "Europe" },
  { name: "Spain", url: "https://kpmg.com/es/es/informes-publicaciones.html", region: "Europe" },
  { name: "Sweden", url: "https://kpmg.com/se/en/insights.html", region: "Europe" },
  { name: "Switzerland", url: "https://kpmg.com/ch/en/insights.html", region: "Europe" },
  { name: "Turkey", url: "https://kpmg.com/tr/en/home/insights.html", region: "Europe" },
  { name: "Ukraine", url: "https://kpmg.com/ua/en/home/insights.html", region: "Europe" },
  { name: "United Kingdom", url: "https://kpmg.com/uk/en/insights.html", region: "Europe" },

  // ---- Middle East ----
  { name: "Bahrain", url: "https://kpmg.com/bh/en/home/insights.html", region: "Middle East" },
  { name: "Israel", url: "https://kpmg.com/il/en/home/insights.html", region: "Middle East" },
  { name: "Jordan", url: "https://kpmg.com/jo/en/home/insights.html", region: "Middle East" },
  { name: "Kuwait", url: "https://kpmg.com/kw/en/home/insights.html", region: "Middle East" },
  { name: "Lebanon", url: "https://kpmg.com/lb/en/home/insights.html", region: "Middle East" },
  { name: "Oman", url: "https://kpmg.com/om/en/home/insights.html", region: "Middle East" },
  { name: "Qatar", url: "https://kpmg.com/qa/en/home/insights.html", region: "Middle East" },
  { name: "Saudi Arabia", url: "https://kpmg.com/sa/en/home/insights.html", region: "Middle East" },
  { name: "United Arab Emirates", url: "https://kpmg.com/ae/en/home/insights.html", region: "Middle East" },

  // ---- Asia-Pacific ----
  { name: "Armenia", url: "https://kpmg.com/am/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Australia", url: "https://kpmg.com/au/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Azerbaijan", url: "https://kpmg.com/az/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Bangladesh", url: "https://kpmg.com/bd/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Cambodia", url: "https://kpmg.com/kh/en/home/insights.html", region: "Asia-Pacific" },
  { name: "China", url: "https://kpmg.com/cn/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Hong Kong SAR", url: "https://kpmg.com/cn/en/home/insights.html", region: "Asia-Pacific" },
  { name: "India", url: "https://kpmg.com/in/en/insights.html", region: "Asia-Pacific" },
  { name: "Indonesia", url: "https://kpmg.com/id/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Japan", url: "https://kpmg.com/jp/ja/home/insights.html", region: "Asia-Pacific" },
  { name: "Kazakhstan", url: "https://kpmg.com/kz/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Korea", url: "https://kpmg.com/kr/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Laos", url: "https://kpmg.com/la/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Macau SAR", url: "https://kpmg.com/cn/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Malaysia", url: "https://kpmg.com/my/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Mongolia", url: "https://kpmg.com/mn/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Myanmar", url: "https://kpmg.com/mm/en/home/insights.html", region: "Asia-Pacific" },
  { name: "New Zealand", url: "https://kpmg.com/nz/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Pakistan", url: "https://kpmg.com/pk/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Philippines", url: "https://kpmg.com/ph/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Singapore", url: "https://kpmg.com/sg/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Sri Lanka", url: "https://kpmg.com/lk/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Taiwan", url: "https://kpmg.com/xx/en/our-insights.html", region: "Asia-Pacific" },
  { name: "Thailand", url: "https://kpmg.com/th/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Uzbekistan", url: "https://kpmg.com/uz/en/home/insights.html", region: "Asia-Pacific" },
  { name: "Vietnam", url: "https://kpmg.com/vn/en/home/insights.html", region: "Asia-Pacific" },

  // ---- Americas ----
  { name: "Argentina", url: "https://kpmg.com/ar/es/home/insights.html", region: "Americas" },
  { name: "Bahamas", url: "https://kpmg.com/bs/en/home/insights.html", region: "Americas" },
  { name: "Barbados", url: "https://kpmg.com/bb/en/home/insights.html", region: "Americas" },
  { name: "Bermuda", url: "https://kpmg.com/bm/en/home/insights.html", region: "Americas" },
  { name: "Brazil", url: "https://kpmg.com/br/en/home/insights.html", region: "Americas" },
  { name: "British Virgin Islands", url: "https://kpmg.com/vg/en/home/insights.html", region: "Americas" },
  { name: "Canada", url: "https://kpmg.com/ca/en/home/insights.html", region: "Americas" },
  { name: "Cayman Islands", url: "https://kpmg.com/ky/en/home/insights.html", region: "Americas" },
  { name: "Chile", url: "https://kpmg.com/cl/es/home/insights.html", region: "Americas" },
  { name: "Colombia", url: "https://kpmg.com/co/es/home/insights.html", region: "Americas" },
  { name: "Costa Rica", url: "https://kpmg.com/cr/es/home/tendencias.html", region: "Americas" },
  { name: "Jamaica", url: "https://kpmg.com/jm/en/home/insights.html", region: "Americas" },
  { name: "Mexico", url: "https://kpmg.com/mx/es/home/tendencias.html", region: "Americas" },
  { name: "Panama", url: "https://kpmg.com/pa/es/home/insights.html", region: "Americas" },
  { name: "Peru", url: "https://kpmg.com/pe/es/home/insights.html", region: "Americas" },
  { name: "Trinidad and Tobago", url: "https://kpmg.com/xx/en/our-insights.html", region: "Americas" },
  { name: "United States", url: "https://kpmg.com/us/en/insights-and-resources.html", region: "Americas" },
  { name: "Uruguay", url: "https://kpmg.com/uy/es/home/insights.html", region: "Americas" },
  { name: "Venezuela", url: "https://kpmg.com/ve/es/home/insights.html", region: "Americas" },
];

export const INSIGHTS_LINKS = RAW;

export const INSIGHTS_REGIONS = [
  "Africa",
  "Europe",
  "Middle East",
  "Asia-Pacific",
  "Americas",
];
